import { EarningsInsightRecapResponse, earningsInsights } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_INSIGHT_RECAP = 'QUERY_KEY_EARNINGS_INSIGHT_RECAP';

export const useGetEarningsInsightRecap = (earningsInsightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHT_RECAP, earningsInsightId],
    queryFn: ({ signal }) => {
      const { path, schema } = earningsInsights.getEarningsInsightRecap;
      return wretchRequest<EarningsInsightRecapResponse>(
        path(earningsInsightId),
        {
          method: 'get',
          schema,
          signal,
        }
      );
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!earningsInsightId,
  });
